import React, { useState, useEffect } from "react";
import styles from "./dashboard.module.css";
import { Avatar, Stack, Pagination, Snackbar } from "@mui/material/";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@material-ui/lab/Alert";
import { Typography, Button } from "@material-ui/core";
import { ReactComponent as VisibilityIcon } from "../../utils/assets/visibilityIcon.svg";
import { ReactComponent as VisibilityIconBlue } from "../../utils/assets/visibilityIconBlue.svg";
import { ReactComponent as VisibilityOff } from "../../utils/assets/visibilityOff.svg";
import { ReactComponent as VisibilityOffBlue } from "../../utils/assets/visibilityOffBlue.svg";
import { DEFAULT_ALERT } from "utils/strings";

export default function Player() {
  const axios = useAxiosPrivate();
  const [members, setMembers] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [edit, setEdit] = useState(false);
  const [removeId, setRemoveId] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState();
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  const handleRemove = (e) => {
    setRemoveId(e);
    setEdit(true);
  };

  const handleCancel = (e) => {
    setRemoveId(null);
    setEdit(false);
  };

  const loadData = async () => {
    try {
      const { data } = await axios.get(
        `/team/players?page=${pageNumber}&page_size=10`
      );
      setCount(data.total_pages);
      setTotalRecords(data.total_records);
      setMembers(
        data.data.sort(function (a) {
          if (a?.status.toLowerCase() === "active") {
            return -1;
          }
          return 0;
        })
      );
      setActive(data.active_records);
      setAlert(DEFAULT_ALERT);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message:
          "You're not in a Team yet. Please ask your team admin to invite you in.",
      });
    }
  };

  const handleDelete = async (memberId) => {
    try {
      await axios.delete(`/team/members/${memberId}`);
      loadData();
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Player successfully deleted.",
      });
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: error.response?.data?.message || "Server error!",
      });
    }
  };

  const handleVisibility = async (memberId, visibility) => {
    try {
      await axios.post(`/team/player_visibility/${memberId}`, {
        visible: !visibility,
      });
      setMembers((prev) =>
        prev.map((item) => {
          if (item.member_id === memberId) {
            item.visible = !visibility;
          }
          return item;
        })
      );
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Server error!",
      });
    }
  };

  const handleChange = (event, value) => {
    setPageNumber(value);
  };

  const handleClose = () => {
    setAlert({
      showAlert: false,
      severity: "success",
      message: "",
    });
  };

  return (
    <div style={{ marginTop: "3.68rem" }}>
      <Snackbar
        open={alert.showAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={alert.severity} onClose={handleClose}>
          {alert.message}
        </Alert>
      </Snackbar>
      <div className={styles.container}>
        <div className={styles.searchBox}>
          <Typography
            variant="h5"
            style={{
              fontSize: "1rem",
              lineHeight: "1rem",
              marginBottom: "1%",
            }}
          >
            You have invited {totalRecords ? totalRecords : "--"} patients.{" "}
            <span
              style={{
                fontFamily: "Poppins",
                fontWeight: "600",
                color: "#0f9bb0",
              }}
            >
              {active ? active : "--"}
            </span>{" "}
            patients accepted your invitation.{" "}
          </Typography>
        </div>
      </div>
      <div className={styles.tableHead}>
        <div className={styles.header}>
          <div className={styles.tittle6} style={{ width: "25%", flexShrink: 0 }}>
            <div className={styles.item2}>
              <div style={{ width: 30, height: 30 }} />
            </div>
            <div className={styles.item3}>
              <Typography
                variant="h5"
                style={{ fontSize: "14px", lineHeight: "1rem" }}
              >
                Name
              </Typography>
            </div>
          </div>
          <div className={styles.tittle2} style={{ width: "20%", flexShrink: 0 }}>
            <Typography
              variant="h5"
              style={{ fontSize: "14px", lineHeight: "1rem" }}
            >
              Email
            </Typography>
          </div>
          <div className={styles.tittle3} style={{ width: "15%", flexShrink: 0 }}>
            <Typography
              variant="h5"
              style={{ fontSize: "14px", lineHeight: "1rem" }}
            >
              Status
            </Typography>
          </div>
          <div className={styles.tittle3} style={{ width: "20%", flexShrink: 0 }}>
            <Typography
              variant="h5"
              style={{ fontSize: "14px", lineHeight: "1rem" }}
            >
              Visible on Dashboard
            </Typography>
          </div>
          <div className={styles.tittle3} style={{ width: "20%", flexShrink: 0 }}>
            <Typography
              variant="h5"
              style={{ fontSize: "14px", lineHeight: "1rem" }}
            >
              Remove
            </Typography>
          </div>
        </div>
      </div>
      {members.map((item, index) => (
        <div
          className={styles.container}
          style={{ cursor: "pointer" }}
          key={index}
        >
          <div className={styles.tBody}>
            <div className={styles.tittle6} style={{ width: "25%", flexShrink: 0 }}>
              <div className={styles.item2}>
                <Avatar
                  alt="Remy Sharp"
                  src={item.avatar_url}
                  sx={{ width: 30, height: 30 }}
                />
              </div>
              <div className={styles.item3}>
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "14px",
                    lineHeight: "1rem",
                    textTransform: "capitalize",
                  }}
                >
                  {item?.first_name}&nbsp;{item?.last_name}
                </Typography>
              </div>
            </div>
            <div className={styles.tittle7} style={{ width: "20%", flexShrink: 0 }}>
              <Typography
                variant="h4"
                style={{
                  fontSize: "14px",
                  lineHeight: "1rem",
                  textTransform: "none",
                }}
              >
                {item?.email}
              </Typography>
            </div>
            <div className={styles.tittle3} style={{ width: "15%", flexShrink: 0 }}>
              <Typography
                variant="h4"
                style={{
                  fontSize: "14px",
                  lineHeight: "1rem",
                  textTransform: "capitalize",
                }}
              >
                {item?.status.toLowerCase()}
              </Typography>
            </div>
            <div className={styles.tittle3} style={{ width: "20%", flexShrink: 0 }}>
              {edit && removeId === item?.member_id ? (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => handleDelete(item?.member_id)}
                  style={{
                    fontSize: "0.9rem",
                    lineHeight: "1.25rem",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontStyle: "normal",
                    width: 100,
                    height: 35,
                    textTransform: "none",
                  }}
                >
                  Remove
                </Button>
              ) : (
                <p className={styles.tdText}>
                  {item.visible ? (
                    item?.status.toLowerCase() === "active" ? (
                      <VisibilityIconBlue
                        style={{ width: "20px", height: "20px" }}
                        onClick={() =>
                          handleVisibility(item.member_id, item.visible)
                        }
                      />
                    ) : (
                      <VisibilityIcon
                        style={{ width: "20px", height: "20px" }}
                        onClick={() =>
                          handleVisibility(item.member_id, item.visible)
                        }
                      />
                    )
                  ) : item?.status.toLowerCase() === "active" ? (
                    <VisibilityOffBlue
                      style={{ width: "20px", height: "20px" }}
                      onClick={() =>
                        handleVisibility(item.member_id, item.visible)
                      }
                    />
                  ) : (
                    <VisibilityOff
                      style={{ width: "20px", height: "20px" }}
                      onClick={() =>
                        handleVisibility(item.member_id, item.visible)
                      }
                    />
                  )}
                </p>
              )}
            </div>
            <div className={styles.tittle3} style={{ width: "20%", flexShrink: 0 }}>
              <p className={styles.tdText}>
                {edit && removeId === item?.member_id ? (
                  <Button
                    fullWidth
                    size="large"
                    color="primary"
                    onClick={() => handleCancel(item)}
                    style={{
                      fontSize: "0.9rem",
                      lineHeight: "1.25rem",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontStyle: "normal",
                      width: 100,
                      height: 35,
                      textTransform: "none",
                      border: "2px solid",
                    }}
                  >
                    Cancel
                  </Button>
                ) : (
                  <CloseIcon
                    sx={{ width: 20, height: 20, color: "#0F9BB0" }}
                    onClick={() => handleRemove(item.member_id)}
                  />
                )}
              </p>
            </div>
          </div>
        </div>
      ))}
      <div className={styles.Pagination}>
        <Stack spacing={2}>
          <Pagination
            count={count}
            page={pageNumber}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
            style={{
              transform: "scale(0.8)",
            }}
          />
        </Stack>
      </div>
    </div>
  );
}
